import { CSSProperties } from 'react';

import {
  PREVIEW_CONTAINER_HEIGHT,
  PREVIEW_CONTAINER_WIDTH
} from 'views/OfferDesign/OfferDesign.consts';
import {
  OfferDesignTypes,
  RenderCardFn
} from 'views/OfferDesign/OfferDesign.types';

import {
  renderBundleCard,
  renderBuyOneGetManyCard,
  renderPopupCard,
  renderProgressBarCard,
  renderProgressBarCardV2,
  renderPromotionCard,
  renderRewardCalendarCard,
  renderRollingOfferCard,
  renderTriggeredPopupCard
} from './OfferDesignPreview.utils';

export const PREVIEW_ELEMENT_ID = 'offer-design-preview';

interface RenderMapOptions {
  isProgressBarV2?: boolean;
}

export const getRenderMap = ({
  isProgressBarV2
}: RenderMapOptions = {}): Record<string, RenderCardFn> => ({
  [OfferDesignTypes.Bundle]: renderBundleCard,
  [OfferDesignTypes.SpecialOffer]: renderPromotionCard,
  [OfferDesignTypes.ProgressBar]: isProgressBarV2
    ? renderProgressBarCardV2
    : renderProgressBarCard,
  [OfferDesignTypes.RollingOffer]: renderRollingOfferCard,
  [OfferDesignTypes.BuyOneGetMany]: renderBuyOneGetManyCard,
  [OfferDesignTypes.PopUp]: renderPopupCard,
  [OfferDesignTypes.TriggeredPopup]: renderTriggeredPopupCard,
  [OfferDesignTypes.RewardCalendar]: renderRewardCalendarCard
});

export const BASE_CONTAINER_STYLE: CSSProperties = {
  width: PREVIEW_CONTAINER_WIDTH,
  position: 'relative'
};

export const ROLLING_OFFER_CONTAINER_STYLE: CSSProperties = {
  ...BASE_CONTAINER_STYLE,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  overflow: 'hidden'
};

export const POPUP_CONTAINER_STYLE: CSSProperties = {
  ...BASE_CONTAINER_STYLE,
  minHeight: PREVIEW_CONTAINER_HEIGHT,
  overflow: 'hidden',
  transform: 'translateZ(0)'
};

export const CONTAINER_STYLE_MAP: Record<string, CSSProperties> = {
  [OfferDesignTypes.PopUp]: POPUP_CONTAINER_STYLE,
  [OfferDesignTypes.TriggeredPopup]: POPUP_CONTAINER_STYLE,
  [OfferDesignTypes.RewardCalendar]: POPUP_CONTAINER_STYLE,
  [OfferDesignTypes.RollingOffer]: ROLLING_OFFER_CONTAINER_STYLE,
  [OfferDesignTypes.BuyOneGetMany]: ROLLING_OFFER_CONTAINER_STYLE
};
